// extracted by mini-css-extract-plugin
export default {"modalContainer":"Z0-z","modalIndicator":"_0-z","prevBtn":"a1-z","nextBtn":"b1-z","body":"c1-z","footer":"d1-z"};